interface OpenDialogConfig {
  url: string
  partNumber: string,
  formats: string
  //partPostId: string
  //sourcePostId: string
}

document.addEventListener("DOMContentLoaded", () => {

  const dialog = document.getElementById("CADPreviewDialog");
  const dialogLoadingEl = document.getElementById("CADPreviewDialogLoading");
  const canvas = document.getElementById("Dialog3dPreview");

  if (!(dialog && dialogLoadingEl && canvas)) {
    console.error('load: all required elements do not exist in the current document');
    return;
  }

  const f_part_number = dialog.querySelector('.f_part_number');
  const threeD = new ThreePreview( canvas );

  document.querySelectorAll(".button-view-3d").forEach((b) => {
    if (b instanceof HTMLElement) {

      b.addEventListener('click', (e) => {
				const gfile = b.dataset.gltf || "";
        openDialog(e, {
          url: '/cad-preview-gltf/' + gfile.substring(0, gfile.lastIndexOf('.')),
          partNumber: b.dataset.partNumber || "",
          formats: b.dataset.formats || ""
        });
        
        document.body.classList.add('dialog-active');
      });
    }
  });

  // handle close
  function closeDialog() {
    document.body.classList.remove('dialog-active');
  }
  dialog.addEventListener('close', closeDialog);
  document.querySelector('.close_dialog')?.addEventListener('click', closeDialog);


  function openDialog(e: MouseEvent, config: OpenDialogConfig) {
    config = config || {};

    if (!(dialog && dialogLoadingEl && f_part_number && canvas)) {
      console.error('openDialog: all required elements do not exist in the current document');
      return;
    }

    f_part_number.innerHTML = config.partNumber;

    dialog.querySelectorAll(".button.button-cad-file").forEach(b => {
      if (b instanceof HTMLElement) {
        b.dataset.partNumber = config.partNumber;
        b.dataset.formats = config.formats;
        //b.dataset.partPostId = config.partPostId;
        //b.dataset.sourcePostId = config.sourcePostId;
      }
    });

    dialogLoadingEl.style.display = 'flex';

    (dialog as any).showModal();

    const pRect = canvas.parentElement?.getBoundingClientRect();
    if (pRect) {
      threeD.resize( pRect.width, pRect.height );
    }

    threeD.load(config.url).then(() => { 
      dialogLoadingEl.style.display = 'none';
    });
  }


  function onResize() {
    if (!(dialog && canvas)) {
      return;
    }

    if (dialog && (dialog as any).open) {
      const pRect = canvas.parentElement?.getBoundingClientRect();
      if (pRect) {
        threeD.resize( pRect.width, pRect.height );
      }
    }
  }

  const onResizeDB = threeD.debounce(onResize, 250);

  window.addEventListener('resize', onResizeDB);
  window.addEventListener('orientationchange', onResizeDB);

});

